import { SlackChannelInput } from 'generated/graphql';
import { IntegrationChannelType } from 'generated/graphql';

export const isValidCreateOutboundIntegrationInput = (
  channelType: IntegrationChannelType,
  slackChannels: SlackChannelInput[],
  emails: string[],
) => {
  switch (channelType) {
    case IntegrationChannelType.Slack:
      return slackChannels.length > 0;
    case IntegrationChannelType.Email:
      return emails.length > 0;
    default:
      return false;
  }
};
